import React from "react";
import { AboutSection } from "../components/AboutSection";
import { CurrentlyWorkingOn } from "../components/CurrentlyWorkingOn";
import { FeaturedThought } from "../components/FeaturedThought";
import { Hero } from "../components/Hero";
import { ProjectsSection } from "../components/ProjectsSection";
import { ReceiptsSection } from "../components/ReceiptsSection";
import { usePageTitle } from "../hooks/usePageTitle";
export function Home() {
  usePageTitle();

  // Home → About → Selected Recent Work → In Progress → Receipts → Thoughts → Contact (footer)
  return <main id="main-content" tabIndex={-1} data-id="element-555" data-mp="29g504ryap0z9">
      <Hero data-id="element-556" data-mp="29fc009tud9q3" />
      <AboutSection data-id="element-557" data-mp="29ek57182jg0v" />
      <ProjectsSection data-id="element-558" data-mp="29i7v7qeb1kau" />
      <CurrentlyWorkingOn data-id="element-559" data-mp="2dhgsv6cgu2bo" />
      <ReceiptsSection data-id="element-560" data-mp="2dirtixam6tyk" />
      <FeaturedThought data-id="element-561" data-mp="2dj9wecrs86fg" />
    </main>;
}